import * as types from '../../actions/types';

const initialState = { loading: false, error: null, proposals: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ORG_FUNCTION_PROPOSAL_LOADING:
      return { ...state, loading: true, error: null };
    case types.ORG_FUNCTION_PROPOSAL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.GET_ALL_ORG_FUNCTION_PROPOSAL_SUCCESS:
      return { ...state, loading: false, proposals: action.payload };
    case types.APPROVE_ORG_FUNCTION_PROPOSAL_SUCCESS:
    case types.REJECT_ORG_FUNCTION_PROPOSAL_SUCCESS:
      return {
        ...state,
        proposals: state.proposals.filter(p => p.id !== action.payload.id),
      };
    case types.BULK_DELETE_ORG_FUNCTION_PROPOSAL:
      return {
        ...state,
        proposals: state.proposals.filter(p => !action.payload.includes(p.id)),
      };
    default:
      return state;
  }
};